module.exports = __webpack_public_path__ + "img/abbotts.2ee6383a.jpg";